'use client';

import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { use } from 'react';
import { DialogContext } from '@/components/features/dialogs/infra/context/DialogContext';
import { Button } from '@/components/ui/button';
import { typographyVariants } from '@/components/ui/typography';
import { useIsMobile } from '@/hooks/useIsMobile';

export default function ProfilePreviewCta({
  layout = 'dashboard',
}: {
  layout?: 'drawer' | 'dashboard';
}) {
  const t = useTranslations('Dashboard.ProfileCompletion');
  const { data: session } = useSession();
  const id = session?.user?.id;
  const { openDialog } = use(DialogContext);
  const [isMobile] = useIsMobile();
  if (!id) return null;

  const openProfileDialog = (
    e: React.MouseEvent<HTMLAnchorElement>,
    userId: string
  ) => {
    if (!isMobile) {
      e.preventDefault();
      openDialog('profile', { userId });
    }
  };

  return (
    <>
      <span
        className={`${typographyVariants({ variant: 'regularText' })} ${
          layout === 'dashboard'
            ? 'md:text-base md:font-semibold'
            : 'mb-7 max-w-52'
        }`}
      >
        {t('see_how_your_profile_appears', {
          accountType: session?.user?.accountType ?? '',
        })}
      </span>
      <Link
        href={`/profile/${id}`}
        onClick={(e) => {
          openProfileDialog(e, id);
        }}
      >
        <Button variant='primary' size='large' className='my-8 md:my-0 md:w-48'>
          {t('view_profile')}
        </Button>
      </Link>
    </>
  );
}
